var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.99963C3.83566 5.37194 4.87439 5 6 5H14C16.7614 5 19 7.23858 19 10V18C19 19.1256 18.628 20.1643 18.0004 21C20.7616 20.9998 23 18.7613 23 16V6C23 3.23858 20.7614 1 18 1H8C5.2387 1 3.0002 3.23838 3 5.99963Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.103 5H13.906C16.957 5 19 7.142 19 10.328V17.681C19 20.858 16.957 23 13.906 23H6.103C3.052 23 1 20.858 1 17.681V10.328C1 7.142 3.052 5 6.103 5ZM8.31656 16.9165C8.47046 17.0704 8.67206 17.1469 8.87366 17.1469C9.07526 17.1469 9.27686 17.0704 9.43076 16.9165L13.7022 12.6451C14.01 12.3373 14.01 11.8387 13.7022 11.5309C13.3944 11.2231 12.8967 11.2231 12.5889 11.5309L8.87366 15.2461L7.29416 13.6666C6.98636 13.3588 6.48866 13.3597 6.18086 13.6675C5.87306 13.9744 5.87306 14.473 6.18086 14.7808L8.31656 16.9165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabCircle);
export default __webpack_public_path__ + "static/media/tab-circle.d660c0507071fbb8cad9653a63560bbf.svg";
export { ForwardRef as ReactComponent };